/**
 * Returns an object that is intended to be spread into an anchor tag.
 * If true is passed in, the anchor tag will open in a new tab.
 */
export function openNewTabProps(openNewTab = true) {
    return {
        target: openNewTab ? '_blank' : undefined,
        rel: openNewTab ? 'noopener noreferrer' : undefined,
    };
}
